import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl } from '@angular/forms'
import { TemplateService } from '@tokeet-frontend/templates'
import { Store } from '@ngrx/store'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { ConfirmDialogService, untilDestroy } from '@tokeet-frontend/tv3-platform'

import { NotifyAutomationBaseComponent } from '../notify-automatotion.component'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-notify-guest-automation',
  templateUrl: './notify-guest-automation.component.html',
  styleUrls: ['./notify-guest-automation.component.scss'],
})
export class NotifyGuestAutomationComponent extends NotifyAutomationBaseComponent {
  constructor(
    protected actions: Actions,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    protected templateService: TemplateService,
    protected confirm: ConfirmDialogService
  ) {
    super(actions, store, amplitudeService, templateService, confirm)
    this.form.addControl('guest', new FormControl(true))
  }

  getAutopilotId() {
    return `autopilot-notify-guest|${this.service}|${this.type}|${this.event}|${this.handler}|${this.idSuffix || ''}`
  }
}
